import { WarriorBattle } from '~/../api/common.types';
import { openSeaWarriorLink } from '~/utils/utils';

const NamingDetails = ({
  warrior,
  isSuccess,
}: {
  warrior: WarriorBattle;
  isSuccess?: boolean;
}) => {
  return (
    <p>
      Level {warrior.level}, HP {warrior.hp}, Type {warrior.type}, Syndicate{' '}
      {warrior.syndicate}, {isSuccess && `ID ${warrior.id},`}{' '}
      <a
        href={openSeaWarriorLink(warrior.id)}
        className="link"
        target="_blank"
        rel="noreferrer"
      >
        Opensea
      </a>
    </p>
  );
};

export default NamingDetails;
